import { IConcessionData, ITicketData } from "../models/payment";
import { IFormatedTicketType, ISeatLayout } from "../models/tickets";
import { FoodBeverageItems } from "../store/foodAndBeverage/type";

export const ticketPriceCalculation = (tickets: IFormatedTicketType[]) => {

  const price = tickets.reduce((total, num) => {
    return total + num.total;
  }, 0);
  let bookingFees = tickets.reduce((bookingFee, num) => {
    return bookingFee + num.bookingFees;
  }, 0);
  bookingFees = parseFloat((bookingFees).toFixed(2));
  return { price, bookingFees, total: price + bookingFees }

}


export const getRndInteger = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min)) + min;
}

export const generateUsersessionId = (theatreId: string, type?: string) => {
  let rand = getRndInteger(1000000000, 9999999999);
  const d = new Date();
  const currentTime =
    d.getDate() +
    "" +
    d.getHours() +
    "" +
    d.getMinutes() +
    "" +
    d.getMilliseconds();
  let session = Math.floor(Math.random() * (999 - 100 + 1) + 100);
  const id = type === 'giftshop' ? theatreId : theatreId.substr(0, 3);
  return `${session}${id}${currentTime}${rand}`;
};

export const checkSeat = (seatrecord: any, seatLayout: ISeatLayout[][]) => {
  let error = 0;
  if (seatrecord && seatrecord.length) {
    seatrecord.forEach((val: any) => {
      const seatObjPrev = seatLayout[val.ParentIndex][val.ChildIndex - 1];
      const seatObjPrevPrev = seatLayout[val.ParentIndex][
        val.ChildIndex - 2
      ];
      const seatObjNext = seatLayout[val.ParentIndex][
        val.ChildIndex + 1
      ];
      const seatObjNextNext = seatLayout[val.ParentIndex][
        val.ChildIndex + 2
      ];

      if (
        seatObjPrev &&
        seatObjPrev['seatType'] !== 'Sold' &&
        seatObjPrev['isAvailable'] === true &&
        seatObjPrev['isBooked'] === false &&
        seatObjPrev['seatType'] !== 'Aisle'
        //   seatObjPrev['isAvailable'] !== false
      ) {
        if (
          seatObjPrevPrev &&
          seatObjPrevPrev['seatType'] !== 'Sold' &&
          (seatObjPrevPrev['isBooked'] === true ||
            seatObjPrevPrev['seatType'] === 'Aisle')
        ) {
          error = 1;
        } else if (!seatObjPrevPrev) {
          error = 1;
        }
      }

      if (
        seatObjNext &&
        seatObjNext['seatType'] !== 'Sold' &&
        seatObjNext['isAvailable'] === true &&
        seatObjNext['isBooked'] === false &&
        seatObjNext['seatType'] !== 'Aisle'
        //   seatObjNext['isAvailable'] !== false
      ) {
        if (
          seatObjNextNext &&
          seatObjNextNext['seatType'] !== 'Sold' &&
          (seatObjNextNext['isBooked'] === true ||
            seatObjNextNext['seatType'] === 'Aisle')
        ) {
          error = 1;
        } else if (!seatObjNextNext) {
          error = 1;
        }
      }
    });
  }
  return { error };
}

export const concessionPriceCalculation = (concession: FoodBeverageItems[]) => {
  return concession.reduce((acc: number, item: FoodBeverageItems) => {
    let itemPrice = concessionModifierPrice(item);
    acc += Number(itemPrice) * Number(item.quantity);
    return acc;
  }, 0)
}

export const concessionModifierPrice = (itm: any) => {
  const item = itm;
  let totalPrice = parseFloat(item?.price);
  if (item?.options) {
    item.options.forEach((option: any) => {
      if (option.selected) {
        option.selected.forEach((modifier: any) => {
          totalPrice += parseFloat(modifier.price);
        });
      }
    });
  }
  else {
    return item?.price;
  }
  return totalPrice;
};

export const formatSeatSwapPayload = (params:any)=>{
  const tickets = JSON.parse(JSON.stringify( params.seatSwapDetails?.tickets));

  const seatIds = params.selectedSeat.reduce((acc:any,v:any, i:number) => {
    const index = tickets.findIndex((tk:any)=>`${tk.SeatRowId}${tk.SeatNumber}` === v.SeatId);
      if(index > -1){
        acc[v.SeatId] = tickets[index].TicketSequenceNumber;
        tickets.splice(index,1);
      }
    return acc;
  },{});

  const payload:any = {
    saleId: params.seatSwapDetails?.id,
    cinemaId: params.currentCinema?.slug,
    bookingId: params.seatSwapDetails?.ticketConfirmationNumber,
    countryId: params.countryId,
    requestType: 'swapSeats',
    seats: params.selectedSeat.map((v:any) => v.SeatId).join(','),
    selectedSeat: params.selectedSeat,
    swaps: params.selectedSeat.map((v:any, i:number) => {
      let sequence = '';
      if(seatIds[v.SeatId]){
        sequence = seatIds[v.SeatId];
      }else{
        const [tks] = tickets.splice(0,1);
        sequence = tks.TicketSequenceNumber
      }
      return {
        ticketSequenceNumber:sequence,
        newSeat: {
          areaNumber: v.AreaNumber,
          rowIndex: v.RowIndex,
          columnIndex: v.ColumnIndex
        },
        isAlreadyBooked: v?.isAlreadyBooked
      }
    }),
    originalSeats: params.seatSwapDetails.seats
  }
  if(params.concession){
    payload['concession'] = params.concession
  }
  console.log('payload',payload)
  return payload;
}

export const formatSeatSwapResponse = (response:any)=>{
  return {
      userSessionId: response.seatSwapDetails?.id,
      selectedSeats: response.selectedSeat,
      total: parseInt((Number(response.seatSwapDetails?.totalAmount)/100).toFixed()),
      ticketTypes: response.seatSwapDetails?.ticketTypes,
      bookingFees: Number(response.seatSwapDetails?.serviceCharge),
      price: response.seatSwapDetails?.ticketTypes?.length > 0 ? Number(response.seatSwapDetails?.ticketTypes?.[0]?.price) : 0,
      bookingId: response?.data?.BookingId,
  }
}

export const formatRefundTicket = (v:ITicketData)=>{
  return { SeatRowId: v.Seat_number?v.Seat_number.split(/\d/).shift():'', SeatNumber: v.Seat_number?v.Seat_number.split(/[A-Za-z]/).pop():'', RowId: v.Id, Ticket_price: v.Ticket_price, package_seat: v.package_seat, sequenceNumber: v.sequenceNumber }
}

export const formatRefundConcession = (v:IConcessionData)=>{
  return { ItemId: v.Item_id, RowId: v.Id, Price: v.Price, LineNumber: v.LineNumber }
}

export const getSingleBookingFee = (hasGL: number, settings: any, films: any) => {
  return Number(
    hasGL === 1 ? settings?.glServiceChargeFee : (films?.sessionAttributes === "Soho" ? settings?.sohoServiceChargeFee : settings?.serviceChargeFee)
  );
}